import React from 'react';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <div className="flex items-center justify-center text-yellow-500 mb-4">
            <i className="fa fa-exclamation-triangle text-2xl mr-2" />
            <h4 className="text-xl font-semibold">The page you were looking for is not found!</h4>
          </div>
          <p className="text-gray-600 mb-8">
            You may have mistyped the address or the page may have moved.
          </p>
          <Link 
            to="/"
            className="px-6 py-3 bg-[#0E4B4B] text-white rounded-md hover:bg-[#126F6F] focus:outline-none focus:ring-2 focus:ring-[#0E4B4B] focus:ring-offset-2 transition-colors duration-200"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error404;
